<template>
  <div style="display:flex;flex-direction:column;gap:12px;">
    <div v-if="empty" style="opacity:0.5;font-style:italic;font-size:13px;">변경 사항이 없습니다.</div>
    <div v-for="(group, idx) in groups" :key="idx" style="display:flex;flex-direction:column;gap:4px;">
      <div style="display:flex;align-items:center;gap:8px;margin-bottom:2px;">
        <span style="font-size:10px;text-transform:uppercase;letter-spacing:0.8px;font-weight:600;opacity:0.55;">지역</span>
        <span style="font-weight:600;font-size:12px;">{{ group.territory }}</span>
      </div>
      <div
        v-for="(line, lidx) in group.lines"
        :key="lidx"
        :style="lineStyle(line.kind)"
      >
        <span style="width:18px;flex-shrink:0;font-weight:700;text-align:center;">{{ lineSign(line.kind) }}</span>
        <span style="font-size:10px;text-transform:uppercase;letter-spacing:0.6px;font-weight:700;opacity:0.85;width:32px;">{{ lineTag(line.kind) }}</span>
        <span style="font-weight:600;">{{ translateAction(line.action) }}</span>
        <span v-if="line.condition" style="opacity:0.8;font-family:ui-monospace,'SF Mono',Menlo,Consolas,monospace;font-size:12px;">{{ line.condition }}</span>
      </div>
    </div>
  </div>
</template>

<script>
function summarizeTerritory(rule) {
  const incl = rule.includedTerritories || []
  const excl = rule.excludedTerritories || []
  if (incl.length === 0 && excl.length === 0) return '전 세계'
  if (incl.length === 0 && excl.length > 0) return `전 세계 (${excl.join(', ')} 제외)`
  if (incl.length > 0 && excl.length === 0) return incl.join(', ')
  return `${incl.join(', ')} (${excl.join(', ')} 제외)`
}

function summarizeAction(rule) {
  const action = (rule.action || '').toLowerCase()
  return action ? action.charAt(0).toUpperCase() + action.slice(1) : 'Unknown'
}

function summarizeCondition(rule) {
  if (!rule.match) return ''
  if (rule.match.minMatchSeconds) return `일치 ≥ ${rule.match.minMatchSeconds}초`
  if (rule.match.minMatchPercent) return `일치 ≥ ${rule.match.minMatchPercent}%`
  return '모든 일치'
}

function ruleKey(rule) {
  return summarizeTerritory(rule)
}

function ruleSig(rule) {
  return `${summarizeAction(rule)}|${summarizeCondition(rule)}`
}

const ACTION_KR = {
  Block: '차단',
  Monetize: '수익화',
  Track: '추적',
  Unknown: '알 수 없음',
}

export default {
  name: 'PolicyRulesDiff',
  props: {
    before: { type: Array, default: () => [] },
    after: { type: Array, default: () => [] },
  },
  computed: {
    groups() {
      const beforeMap = new Map()
      const afterMap = new Map()
      ;(this.before || []).forEach((r) => beforeMap.set(ruleKey(r), r))
      ;(this.after || []).forEach((r) => afterMap.set(ruleKey(r), r))
      const territories = new Set([...beforeMap.keys(), ...afterMap.keys()])
      const out = []
      for (const t of territories) {
        const b = beforeMap.get(t)
        const a = afterMap.get(t)
        const lines = []
        if (b && a) {
          if (ruleSig(b) !== ruleSig(a)) {
            lines.push({ kind: 'remove', action: summarizeAction(b), condition: summarizeCondition(b) })
            lines.push({ kind: 'add', action: summarizeAction(a), condition: summarizeCondition(a) })
          }
        } else if (a && !b) {
          lines.push({ kind: 'add', action: summarizeAction(a), condition: summarizeCondition(a) })
        } else if (b && !a) {
          lines.push({ kind: 'remove', action: summarizeAction(b), condition: summarizeCondition(b) })
        }
        if (lines.length) out.push({ territory: t, lines })
      }
      return out
    },
    empty() {
      return this.groups.length === 0
    },
  },
  methods: {
    lineStyle(kind) {
      const base = {
        display: 'flex',
        gap: '10px',
        alignItems: 'center',
        paddingLeft: '8px',
        fontSize: '12px',
        fontFamily: "ui-monospace,'SF Mono',Menlo,Consolas,monospace",
      }
      if (kind === 'add') return { ...base, color: '#1f9d55' }
      if (kind === 'remove') return { ...base, color: '#d04444' }
      return { ...base, color: 'rgba(0,0,0,0.65)' }
    },
    lineSign(kind) {
      if (kind === 'add') return '+'
      if (kind === 'remove') return '−'
      return '·'
    },
    lineTag(kind) {
      if (kind === 'add') return '추가'
      if (kind === 'remove') return '삭제'
      return ''
    },
    translateAction(action) {
      return ACTION_KR[action] || action
    },
  },
}
</script>
